export default "__VITE_ASSET__VRV2H$Be__"